const updatePasswordLength = input => {
    const feedback = input.form.querySelector('.password-length-feedback');
    const icon = feedback.querySelector('i');
    const length = [...input.value.replace(/^[ \t\n\r\u0000\u000B]+|[ \t\n\r\u0000\u000B]+$/g, '')].length;
    const complete = length >= input.minLength;

    feedback.classList.toggle('complete', complete);
    feedback.classList.toggle('incomplete', input.value.length > 0 && !complete);
    icon.classList.toggle('fa-circle-x', !complete);
    icon.classList.toggle('fa-circle-check', complete);
    input.setCustomValidity(complete ? '' : feedback.dataset.incomplete);

    Array.from(input.form.elements).filter(element => element.type === 'submit').forEach(button => {
        button.disabled = !complete;
    });

    return complete;
};

const validatePasswordRequirements = form => {
    const input = form.querySelector('[data-password-length]');

    if (!input || updatePasswordLength(input)) {
        return true;
    }

    input.reportValidity();

    return false;
};

export const handlePasswordRequirementsSubmit = event => {
    if (!validatePasswordRequirements(event.target)) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
};

export const handlePasswordLength = event => {
    if (event.target.matches('[data-password-length]')) {
        updatePasswordLength(event.target);
    }
};

export const initializePasswordRequirements = root => {
    root.querySelectorAll('[data-password-length]').forEach(updatePasswordLength);
};
